module.exports = __webpack_public_path__ + "img/096-cloud-2.cce7ab41.svg";